const Vr1 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-3/PNG%20n.3/3d%203-3/publish%203-3/`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 3 Level 3 Tour"
        ></iframe>
      </div>
    );
};

export default Vr1;
